import Api from '@/services/Api';

export default {
  getCoD4(cid, server) {
    return Api().get('stats/q3', {
      params: {
        cid,
        server,
      },
    });
  },
  getCSGO(steamid, server) {
    return Api().get('stats/csgo', {
      params: {
        steamid,
        server,
      },
    });
  },
};
